/**
 * FLEXA free-delivery progress bar: live updates.
 *
 * WHY THIS REPLACES BROADCAST'S OWN HANDLING
 * Broadcast's cart component recomputes the target in the browser as
 *     100 * data-free-shipping-limit * window.Shopify.currency.rate
 * That forces the stored threshold to be in shop currency and makes the bar
 * drift every time the FX rate moves. It also has no way to know whether the
 * cart is a Postal cart or a Pallet cart, because that comes from product tags.
 *
 * Our markup therefore does not carry data-free-shipping or
 * data-free-shipping-limit, so Broadcast's component finds nothing and leaves
 * the block alone. Instead, after any cart change we ask the server for the
 * numbers, which keeps every decision (market thresholds, the Postal/Pallet
 * rule, money formatting) in Liquid in one place.
 *
 * Deliberately no build step, no module, no dependencies: it has to survive
 * being dropped into a vintage Liquid theme years from now.
 */
(function () {
  'use strict';

  var ROOT = '[data-flexa-free-shipping]';
  var STATE_URL = (window.theme && window.theme.routes && window.theme.routes.root_url
    ? window.theme.routes.root_url
    : '/').replace(/\/$/, '') + '/?section_id=api-flexa-free-shipping';

  var inFlight = false;
  var queued = false;

  /** Apply a state payload to every bar on the page (drawer and cart page). */
  function apply(state) {
    var bars = document.querySelectorAll(ROOT);
    if (!bars.length) return;

    Array.prototype.forEach.call(bars, function (bar) {
      // data-flexa-free-shipping is "true" only when the market actually has a
      // qualified message translated. Without one there is nothing to switch to,
      // so the bar stays in its counting-down state.
      var hasSuccessMessage = bar.getAttribute('data-flexa-free-shipping') === 'true';

      bar.setAttribute('data-flexa-free-shipping-limit', state.limit);
      bar.setAttribute('data-flexa-stream', state.stream);
      bar.classList.toggle('is-success', hasSuccessMessage && state.qualified);

      var amount = bar.querySelector('[data-flexa-left-to-spend]');
      if (amount) amount.innerHTML = state.remaining_formatted;

      var progress = bar.querySelector('[data-flexa-progress-bar]');
      if (progress) progress.value = state.percent;

      var graph = bar.querySelector('[data-flexa-progress-graph]');
      if (graph) graph.style.setProperty('--stroke-dashoffset', String(state.dashoffset));
    });
  }

  /** Fetch the state section and hand the parsed JSON to apply(). */
  function refresh() {
    if (inFlight) { queued = true; return; }
    if (!document.querySelector(ROOT)) return;

    inFlight = true;
    fetch(STATE_URL, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // The Section Rendering API returns the section wrapped in its own
        // markup, so parse rather than regex it out.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-flexa-fs-state]');
        if (!node) return;
        apply(JSON.parse(node.textContent));
      })
      .catch(function () {
        // A failed refresh leaves the last server-rendered numbers in place,
        // which are stale but never wrong-looking. Nothing to recover.
      })
      .then(function () {
        inFlight = false;
        // Coalesce the bursts that come from holding down a quantity stepper.
        if (queued) { queued = false; refresh(); }
      });
  }

  var schedule = (function () {
    var timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 120);
    };
  })();

  // Broadcast fires these after it has finished talking to /cart.
  ['theme:cart:change', 'theme:cart:update', 'theme:cart:add', 'theme:product:added']
    .forEach(function (name) { document.addEventListener(name, schedule); });

  // Opening the drawer re-inserts markup that may predate the last change.
  document.addEventListener('theme:cart-drawer:open', schedule);
})();
